/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface GoldenTransferRegistrationDto {
  network: GoldenTransferRegistrationDto.NetworkEnum;
  contract: string;
  tokenName: string;
  tokenCode: string;
  from: string;
  to: string;
  amount: number;
  direction: GoldenTransferRegistrationDto.DirectionEnum;
  transferStatus: GoldenTransferRegistrationDto.TransferStatusEnum;
  comment?: string;
  timestamp: string;
  txHash?: string;
  networkFee?: number;
  feeAsset?: string;
  businessEntity: GoldenTransferRegistrationDto.BusinessEntityEnum;
}
export namespace GoldenTransferRegistrationDto {
  export const NetworkEnum = {
    Trc20: 'TRC20',
    Erc20: 'ERC20',
    Bank: 'BANK',
    Tassat: 'TASSAT',
    MaticErc20: 'MATIC_ERC20',
  } as const;
  export type NetworkEnum = (typeof NetworkEnum)[keyof typeof NetworkEnum];
  export const DirectionEnum = {
    Deposit: 'DEPOSIT',
    Withdraw: 'WITHDRAW',
    Internal: 'INTERNAL',
    DepositRebate: 'DEPOSIT_REBATE',
    WithdrawRebate: 'WITHDRAW_REBATE',
    InternalDeposit: 'INTERNAL_DEPOSIT',
    InternalWithdraw: 'INTERNAL_WITHDRAW',
  } as const;
  export type DirectionEnum = (typeof DirectionEnum)[keyof typeof DirectionEnum];
  export const TransferStatusEnum = {
    Pending: 'PENDING',
    Error: 'ERROR',
    Settled: 'SETTLED',
  } as const;
  export type TransferStatusEnum = (typeof TransferStatusEnum)[keyof typeof TransferStatusEnum];
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
